
import ImageHeader from '@/components/core/ImageHeader';

export default {
  scrollToTop: true,
  components: {
    ImageHeader,
  },
  head() {
    return {
      title: "Influencer Marketing Services in Goa - Goa App",
      meta: [{
        hid: 'description',
        name: 'description',
        content: 'Influencer Marketing Services helps promote your products & services. Influence your customers by collaborating with those your customers know and trust.'
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: 'influencer marketing in goa, influencer marketing agency in goa, influencer marketing strategy in goa, influencer marketing services in goa'
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: 'Influencer Marketing Services in Goa - Goa App'
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: 'Influencer Marketing Services helps promote your products & services. Influence your customers by collaborating with those your customers know and trust.'
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: 'Influencer Marketing Services in Goa - Goa App'
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: 'Influencer Marketing Services helps promote your products & services. Influence your customers by collaborating with those your customers know and trust.'
      },
      {
        hid: 'og:image:alt',
        property: 'og:image:alt',
        content: 'Influencer Marketing Services in Goa - Goa App'
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: this.$config.siteUrl + '/img/service-imgs/influencer-marketing.webp'
      },
      {
        hid: 'image',
        property: 'image',
        content: this.$config.siteUrl + '/img/service-imgs/influencer-marketing.webp'
      },
      {
        hid: 'twitter-image',
        property: 'twitter:image',
        content: this.$config.siteUrl + '/img/service-imgs/influencer-marketing.webp'
      },

      ],
    }
  },
  scrollToTop: true,
  data() {
    return {
      title: 'Influencer Marketing Services in Goa - Goa App',
      description: 'Influencer Marketing Services helps promote your products & services. Influence your customers by collaborating with those your customers know and trust.',
      eventCategoryModal: false,
      schemaData: [],

      interLinks: {
        "title": "Explore More Services on Goa App",
        "links": [
          {
            "sub_title": "Top Services",
            "interLinks": [
              {
                "name": "Search Engine Optimization in Goa",
                "url": "/search-engine-optimization"              
              },
              {
                "name": "Social Media Marketing in Goa",
                "url": "/social-media-marketing"
              },
              {
                "name": "Advertising in Goa",
                "url": "/Advertising"
              },
              {
                "name": "Website Development in Goa",
                "url": "/website-development"
              },
              {
                "name": "Graphic Designing in Goa",
                "url": "/graphic-design"
              },
              {
                "name": "Influencer Marketing in Goa",
                "url": "/influencer-marketing"
              },
              {
                "name": "Content Marketing in Goa",
                "url": "/content-marketing"
              }

            ]
          },
        ]
      }
    };
  },


jsonld() {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Service",
        "@id": "https://goa.app/influencer-marketing/#Service",
        "url": "https://goa.app/influencer-marketing",
        "name": "Influencer Marketing",
        "description": "Influence your consumers by collaborating with individuals your consumers know and trust. Contact a leading influencer marketing agency in Goa for campaigns.",
        "image": "https://goa.app/img/service-imgs/influencer-marketing.webp",
        "serviceType": "Digital Marketing",
        "additionalType": "serviceOutput",
        "providerMobility": "provider",
        "provider": {
          "@type": "Corporation",
          "name": "Goa App",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Goa",
            "postalCode": "403505"
          },
          "telephone": "+91 9049248689"
        },
        "areaServed": {
          "@type": "City",
          "name": "Goa"
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Influencer Marketing",
          "itemListElement": [
            {
              "@type": "Offer",
              "name": "Smart Creator Partnerships"
            },
            {
              "@type": "Offer",
              "name": "Creative Campaign Creation"
            },
            {
              "@type": "Offer",
              "name": "Turning short spurts into long term gains"
            },
            {
              "@type": "Offer",
              "name": "Maintaining Relationships"
            },
            {
              "@type": "Offer",
              "name": "Sponsored Influential Mentions"
            },
            {
              "@type": "Offer",
              "name": "Campaign Analysis"
            }
          ]
        }
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What is influencer marketing?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Influencer marketing uses local content creators with dedicated followings to promote brands. These influencers are trusted for their expertise in specific niches like fashion, food, beauty, and tech. They create relatable content that resonates more with their audience than traditional celebrities, making them effective for targeted brand promotion and engagement."
            }
          },
          {
            "@type": "Question",
            "name": "Is influencer marketing appropriate for every brand?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Influencer marketing is highly effective in sectors like hospitality, tech, beauty, fashion, lifestyle, travel, and wellness. While some industries may pose more challenges, with the right strategy and expertise, influencer marketing can be adapted to successfully promote nearly any brand, leveraging the influencer’s connection with their audience."
            }
          },
          {
            "@type": "Question",
            "name": "How do you deal with fake influencers?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "At Goa App, we use advanced tools and thorough analysis to verify the authenticity of influencers. We look beyond follower counts to examine engagement rates, audience demographics, and content quality. By focusing on genuine reach and influence, we ensure partnerships with trustworthy influencers who can deliver real results."
            }
          },
          {
            "@type": "Question",
            "name": "How many influencers do I need to run an effective campaign?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "The number of influencers needed depends on your marketing goals. For increasing brand awareness, a larger number of influencers spread over a longer period can be effective. However, we prioritize the quality and influence of each influencer, focusing on their ability to drive engagement and influence purchase decisions rather than just sheer numbers."
            }
          },
          {
            "@type": "Question",
            "name": "Why should I be doing influencer marketing?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Influencer marketing builds brand trust and awareness by leveraging the established credibility of influencers. It’s a powerful way to drive sales, increase social media following, and enhance your content strategy. When done right, it boosts SEO and provides your brand with valuable traction and access to new audiences you might otherwise struggle to reach."
            }
          },
          {
            "@type": "Question",
            "name": "How much does influencer marketing cost?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "The cost of influencer marketing varies based on the campaign scope, the type of influencers, their genuine following, the platform used, and the content required. An established blogger writing a detailed post will typically charge more than a simple Instagram mention. Contact Goa App for a tailored cost guide that fits your specific needs and goals."
            }
          },
          {
            "@type": "Question",
            "name": "Will an influencer help me sell my product?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Influencers can significantly increase your brand’s reach, engagement, and trust, leading to long-term benefits like improved sentiment and site traffic. While you might not see an immediate spike in sales, the increased visibility and credibility will influence consumer purchasing decisions over time, providing a lasting impact on your brand."
            }
          }
        ]
      }
    ]
  };
},

  mounted() {
    document.body.classList.add('modalOverflow');

    this.getHomeActitvitesData();
    this.getActitvitesData();
    this.getActitvitesCategoriesData();

    if (localStorage.getItem('recentlyViewed')) {
      this.recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'))
    }

    if (localStorage.getItem('activitiesFilter')) {
      localStorage.removeItem('activitiesFilter');
    }
    this.$parent.$emit("sentInterLinks", this.interLinks);
  },

  destroyed() {
    document.body.classList.remove('modalOverflow')
    if (document.getElementById('filterClose'))
      document.getElementById('filterClose').click();
  },

  methods: {
    async getHomeActitvitesData() {
      this.allHomeActivitiesData = await fetch(this.$config.fetchUrl +
        '/api/posts/app/getActivitiesForActivityPageWithSlug').then(res => res
          .text());
      this.allHomeActivitiesData = this.getCryptKey(this.allHomeActivitiesData);
      this.homeactLoading = false;
      this.$nextTick(() => {
        if (this.allHomeActivitiesData) {
          var schemaResult = Object.keys(this.allHomeActivitiesData).map((key) => [this.allHomeActivitiesData[
            key].data]);
          schemaResult = schemaResult.flat(2);
          this.schemaData = [...new Map(schemaResult.map(v => [v.post._id, v])).values()]
        }
      })
      //this.changeThingsToDo(0)
    },

    async getActitvitesData() {
      this.allActivitiesData = await fetch(this.$config.fetchUrl + '/api/coupons/app/featuredCoupons').then(res =>
        res
          .text());
      this.allActivitiesData = this.getCryptKey(this.allActivitiesData);
      this.actLoading = false;
      // this.$nextTick(() => {
      //   if (this.allHomeActivitiesData) {
      //     this.schemaData = [...this.allHomeActivitiesData.featuredActivities, ...this.allHomeActivitiesData.photography, ...this.allHomeActivitiesData.hiddenGems];
      //     this.schemaData = [...new Map(this.schemaData.map(v => [v.post._id, v])).values()]
      //   }
      // })
    },

    async getActitvitesCategoriesData() {
      this.featuredCatsLoading = true;
      this.featuredCats = await fetch(this.$config.fetchUrl + '/api/posts/app/getCategoriesForActivityPageWithSlug').then(res =>
        res
          .text());
      this.featuredCats = this.getCryptKey(this.featuredCats);
      this.featuredCatsLoading = false;
    },

    changeThingsToDo(id) {
      switch (id) {
        case 0:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
          break;
        case 1:
          this.thingsToDo = this.allHomeActivitiesData.photography;
          break;
        case 2:
          this.thingsToDo = this.allHomeActivitiesData.hiddenGems;
          break;
        case 3:
          this.thingsToDo = this.allHomeActivitiesData.specialMoments;
          break;
        case 4:
          this.thingsToDo = this.allHomeActivitiesData.monsoonActivities;
          break;
        default:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
      }
    },

    getSpace(key) {
      return key.replace(/([A-Z])/g, " $1")
    },

    activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return '';
      }
    },

    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/places.svg`)
    },

    activityVenue(seller) {
      if (seller && seller.length > 0 && seller[0].venue) {
        return seller[0].venue.name
      }
      return ""
    },

    activityDuration(seller) {
      if (seller && seller.length > 0 && seller[0].durationInHours) {
        return seller[0].durationInHours
      }
      return ""
    },

    activityPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].strikePrice) {
        return seller[0].tickets[0].prices[0].strikePrice
      }
      return 0
    },

    activityDiscountPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].price) {
        return seller[0].tickets[0].prices[0].price
      }
      return 0
    },

    checkIsOffer(seller) {
      let strikePrice = this.activityPrice(seller);
      let price = this.activityDiscountPrice(seller);
      if (strikePrice > price) {
        return true
      }
      return false
    },

    offerPercentage(seller) {
      if (this.checkIsOffer(seller)) {
        let strikePrice = this.activityPrice(seller);
        let price = this.activityDiscountPrice(seller);
        let offerPercentage = strikePrice - price;
        if (offerPercentage > 0) {
          return ((100 * (strikePrice - price) / strikePrice) > 0 && (100 * (strikePrice - price) /
            strikePrice) < 100) ? parseFloat((100 * (strikePrice - price) / strikePrice).toFixed(0)) : 0
        } else return 0
      }
      return 0
    },

    categoryBtnClicked(item) {
      if (item) {
        this.$router.push({
          path: item
        })
      }
    },

  }
}
